module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-tin-mill-finish-723-scale.9a99ce75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-tin-mill-finish-723-scale.jpg
// module id = 1127
// module chunks = 37